import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, Form, Input, Label, Row, Table } from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../../api"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"
import DatePicker from "react-datepicker";
import getDay from "date-fns/getDay"
import Select from "react-select"
import Switch from "react-switch"
const AddSpecialiteMastere = props => {

  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  const [capaciteExterne, setCapaciteExterne] = useState("")
  const [capaciteInterne, setCapaciteInterne] = useState("")
  const [array, setArray] = useState([
    {
      label: "",
      capacite_externe: "",
      capacite_interne: "",
      etat: 0,
      etat_matieres: 0,
    },
  ]);

  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const save = async () => {
    const cleanedArray = array.map((s) => ({
      ...s,
      capacite_externe: Number(s.capacite_externe) || 0,
      capacite_interne: Number(s.capacite_interne) || 0,
      etat: s.etat === 1 ? 1 : 0,
    }));
    try {
      const res = await API.post("master/specialite_master/add", {
        annee_id: annee_id,
        array: cleanedArray,
        user_id: user_id,
      });
      toast.success("🔓✔️ Spécialité Mastère ajoutée avec succès", {
        containerId: "A",
      });
      props.setSection(1);
    } catch (error) {
      toast.error("⛔ Erreur lors de l'enregistrement des spécialités", {
        containerId: "A",
      });
    }
  };
  useEffect(async () => {
    const res = await API.post("master/get_specialite_master",{annee_id}).then(res => {
      setArray(res.data.Specialites)
    })
  }, [])
  const Offsymbol = () => {
    return (
      <div
        title="Désactivé"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        D
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        title="Activé"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        A
      </div>
    );
  };


  const handleCapaciteExterneChange = (index, value) => {
    setArray(prev =>
      prev.map((item, i) =>
        i === index
          ? { ...item, capacite_externe: value }
          : item
      )
    );
  };

  const handleCapaciteInterneChange = (index, value) => {
    setArray(prev =>
      prev.map((item, i) =>
        i === index
          ? { ...item, capacite_interne: value }
          : item
      )
    );
  };

  const handleEtatChange = (index) => {
    setArray(prev =>
      prev.map((item, i) =>
        i === index
          ? { ...item, etat: item.etat === 1 ? 0 : 1 }
          : item
      )
    );
  };

  return (
    <React.Fragment>
      <Row>
        <AvForm>
          <Form>
            <Row >
              <Table className="mt-3" striped bordered hover>
                <thead>
                  <th style={{textAlign: "center"}}></th>
                  <th style={{textAlign: "center"}}>Spécialité</th>
                  <th style={{textAlign: "center"}}>Capacité externe</th>
                  <th style={{textAlign: "center"}}>Capacité interne</th>
                  <th style={{textAlign: "center"}}>Etat</th>
                </thead>
                <tbody>

                {array.map((specialite, index) => (
                  <tr key={index}>
                    <td style={{textAlign: "center"}}>{index + 1}</td>
                    <td style={{textAlign: "center"}}>{specialite.label}</td>
                    <td style={{ textAlign: "center" }}>
                      <Input
                        type="number"
                        className="form-control text-center"
                        placeholder="Capacité externe"
                        value={specialite.capacite_externe}
                        onChange={(e) =>
                          handleCapaciteExterneChange(index, e.target.value)
                        }
                      />
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <Input
                        type="number"
                        className="form-control text-center"
                        placeholder="Capacité interne"
                        value={specialite.capacite_interne}
                        onChange={(e) =>
                          handleCapaciteInterneChange(index, e.target.value)
                        }
                      />
                    </td>
                    <td style={{textAlign: "center"}}>
                      <Switch
                        uncheckedIcon={<Offsymbol />}   // Désactivé
                        checkedIcon={<OnSymbol />}       // Activé
                        className="me-1 mb-sm-8 mb-2"
                        onColor="#34c38f"
                        checked={specialite.etat === 1}  // 🔥 Correct
                        disabled={specialite.etat_matieres === 1}  // 🔥 Correct
                        onChange={() => handleEtatChange(index)}  // 🔥 Pour modifier l’état
                      />
                    </td>
                  </tr>
                ))}
                </tbody>

              </Table>
            </Row>
          </Form>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                className="text-center mt-4"
              >
                <Button
                  type="button"
                  color="warning"
                  className="btn btn-warning  mb-2 me-2"
                  onClick={props.back}
                >
                  {props.t("Annuler")}
                </Button>
              </div>
            </Col>
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
                className="text-center mt-4"
              >
                <button
                  type="button"
                  className="btn btn-primary "
                  onClick={save}
                >
                  {props.t("Confirmer")}
                </button>
              </div>
            </Col>
          </div>
        </AvForm>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withTranslation()(AddSpecialiteMastere)
AddSpecialiteMastere.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
